import React from 'react';
import { shape, string, array, object } from 'prop-types';

import LabelBuilder from '../../../../label-builder';
import { getFontClassName } from '../../common';

export const LabelComponent = (props) => {
  const { label } = props;
  const { text, values, styles: parentStyles = {} } = label ?? {};
  const parentColor = parentStyles?.color;

  const class_name = getFontClassName(parentStyles);

  const newValues = values?.map(({ styles = {}, ...remainingProps }) => {
    const className = getFontClassName(styles);

    return {
      className,
      styles: { color: styles?.color ?? parentColor },
      ...remainingProps,
    };
  });

  return (
    <LabelBuilder
      html_tag="label"
      text={text}
      values={newValues}
      class_name={class_name}
      styles={{ color: parentColor }}
    />
  );
};

LabelComponent.propTypes = {
  label: shape({
    text: string,
    values: array,
    styles: object,
  }),
};
